import { useTranslation } from "react-i18next";

import { useUserWebAppPresentationFeatures } from "../../hooks/useUserWebAppPresentationFeatures";
import { isWithinPendingWindow } from "../../utils/results/metricPending";
import ResultPendingDots from "./ResultPendingDots";
import QualityStatusDisplay from "./QualityStatusDisplay";
import { usePendingTick } from "./usePendingTick";

/**
 * Renders a Pass/Fail quality cell. When the quality status has not resolved yet
 * (null/undefined) but the recording is recent, it shows a "Calculating…"
 * indicator instead of the empty fallback ("--"); once the pending window has
 * passed (or the recording is old) it falls back to "--". Mirrors
 * {@link MetricValue} for numeric metrics.
 */
export default function QualityValue({
  status,
  recordingTimestamp,
  fallback = "--",
  forcePending = false,
}) {
  useTranslation();
  const { qualityStatusPillsEnabled = false } =
    useUserWebAppPresentationFeatures();
  const hasValue = Boolean(status);
  const pending =
    !hasValue && (forcePending || isWithinPendingWindow(recordingTimestamp));

  usePendingTick(recordingTimestamp, pending);

  if (hasValue) {
    return (
      <QualityStatusDisplay
        status={status}
        fallback={fallback}
        qualityStatusPillsEnabled={qualityStatusPillsEnabled}
      />
    );
  }

  if (pending) {
    return <ResultPendingDots className="muted-text" />;
  }

  return <>{fallback}</>;
}
